import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NavBarProfile from './NavBar/NavBarProfile';
import ProfileForm from './Form/ProfileForm';

function ProfileCreation() {
  return (
    <div className="row flex-nowrap">
      {/* Navbar */}
      <NavBarProfile />

      <div className="col py-3">
        {/*<h1 className="text-center fw-bold mb-5">Conjuror for Scratch Encore</h1>*/}
        <div className="text-center">
          <img src={require("../assets/images/conjurorlogo.png")} className="w-25 mb-5" alt="logo"></img>
        </div>

        <div className="container w-75">
          <h5 className="fw-bold">Classroom profile: Help us customize your Scratch Encore modules</h5>
          <p>The information in this profile helps Conjuror customize your Scratch Encore modules. Feel free to edit it at any time.</p>
          <p className="mb-4 fst-italic text-primary">To protect your privacy, this information is stored temporarily as a cookie and used only to create your projects. Your data will not be shared or sold in any way.</p>
          <p><span className="text-danger">* </span> All fields are required.</p>
          <ProfileForm />
        </div>

      </div>

    </div>
  );
}

export default ProfileCreation;